/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-computed-key */
/* eslint-disable array-callback-return */


import React, { useRef, useState, useEffect } from "react";
import { salvarMesa } from "../../../services/MesaService";
import SwitchInput from "./SwitchInput";

/**
 * props:
 * - data
 * - onSubmit
 */

function CadMesaModal(props) {
  const [erro, setErro] = useState("");
  const [mesa, setMesa] = useState({
    descricao: "",
    situacao: "Ativo",
    mesadelivery: "M",
  });
  const btnClose = useRef("");
  const btnSalvar = useRef("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    setMesa(props.data);
  }, [props.data]);

  function onSubmit(event) {
    mesa.cod_org = localStorage.getItem("cod_org");

    salvarMesa(mesa.cod_mesa, mesa, token)
      .then((result) => {
        btnClose.current.click();
        if (props.onSubmit) props.onSubmit(result);

        mesa.descricao = "";
        mesa.mesadelivery = "";
        mesa.situacao = "";
      })
      .catch((err) => {
        console.error(err.response ? err.response.data : err.message);
        setErro(err.response ? err.response.data : err.message);
      });

    props.onSubmit(event);
  }

  function onInputChange(event) {
    setMesa((prevState) => ({
      ...prevState,
      [event.target.id]: event.target.value,
    }));
  }

  console.log(props);
  useEffect(() => {
    mesa.descricao = props.data.descricao;
    mesa.situacao = props.data.situacao;
    mesa.mesadelivery = props.data.mesadelivery;
  }, [props]);
  return (
    <div
      className="modal fade"
      id="modalMesa"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modalTitleNotify"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <p className="modal-title" id="modalTitleNotify">
              {props.data.cod_mesa ? "Alterar " : "Nova "}Mesa
            </p>
            <button
              ref={btnClose}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="descricao" align="Left">
                    Descrição
                  </label>
                  <input
                    className="form-control"
                    id="descricao"
                    type="text"
                    placeholder="Informe a Descrição"
                    value={mesa.descricao}
                    onChange={onInputChange}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-9 mb-3">
                  <label htmlFor="tipo" align="Left">
                    Tipo
                  </label>
                  <select
                    className="form-control"
                    value={mesa.mesadelivery}
                    name="mesaDelivery"
                    id="mesadelivery"
                    onChange={onInputChange}
                  >
                    <option value="M">Mesa</option>
                    <option value="D">Delivery</option>
                  </select>
                </div>
                <div className="col-md-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="tipo" align="Left">
                      Situação
                    </label>
                    <SwitchInput
                      id="situacao"
                      text={mesa.situacao}
                      onChange={onInputChange}
                      isChecked={mesa.situacao}
                    />
                  </div>
                </div>
              </div>
              <div className="row"></div>
            </div>
          </div>
          <div className="modal-footer">
            {erro ? (
              <div className="alert alert-danger mt-1 col-9 py-1">{erro}</div>
            ) : (
              <React.Fragment></React.Fragment>
            )}
            <button
              ref={btnSalvar}
              type="button"
              className="btn btn-sm btn-primary"
              onClick={onSubmit}
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CadMesaModal;
